import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, MapPin } from 'lucide-react';

const VegrFooter = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Vegr */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-white/10 rounded-lg p-2 flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_uoe-highland/artifacts/pk36mmt7_Vegr%20roads%20app%20transparent.png" 
                  alt="Vegr Logo" 
                  className="w-full h-full object-contain"
                  style={{ filter: 'brightness(0) invert(1)' }}
                />
              </div>
              <div>
                <h3 className="font-bold text-lg">Vegr</h3>
                <p className="text-xs text-gray-400">Road Monitoring</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Real-time road and weather monitoring for Northeast India and Highland Asia.
            </p>
            <p className="text-gray-500 text-xs italic">
              From Old Norse <em>vegr</em> (road, way)
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/vegr" className="text-gray-400 hover:text-green-400 transition-colors">Live Map</Link></li>
              <li><Link to="/vegr/report" className="text-gray-400 hover:text-green-400 transition-colors">Report Condition</Link></li>
              <li><Link to="/vegr/about" className="text-gray-400 hover:text-green-400 transition-colors">About Vegr</Link></li>
              <li>
                <a 
                  href="https://highlandinstitute.org" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-green-400 transition-colors inline-flex items-center"
                >
                  Highland Institute
                  <ExternalLink className="w-3 h-3 ml-1" />
                </a>
              </li>
            </ul>
          </div>

          {/* Highland Institute Apps */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Highland Institute Apps</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>• <strong className="text-white">Mímir</strong> - Dreams</li>
              <li>• <strong className="text-white">Saga</strong> - Data</li>
              <li>• <strong className="text-white">Eir</strong> - Medical pluralism</li>
              <li>• <strong className="text-white">Yggdrasil</strong> - Archives</li>
              <li>• <strong className="text-white">Skald</strong> - Learning</li>
              <li>• <strong className="text-green-400">Vegr</strong> - Roads (current)</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-300 mb-2">
            © 2025 The Highland Institute
          </p>
          <p className="text-gray-400 text-sm mb-1">
            Digital Laboratory | 
            <a 
              href="https://www.highlandinstitute.org" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-green-400 hover:text-green-300 ml-1"
            >
              www.highlandinstitute.org
            </a>
          </p>
          <p className="text-gray-500 text-xs">All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default VegrFooter;